import { render, staticRenderFns } from "./TicketChatColumn.vue?vue&type=template&id=7a77b7b1&scoped=true"
import script from "./TicketChatColumn.vue?vue&type=script&lang=js"
export * from "./TicketChatColumn.vue?vue&type=script&lang=js"
import style0 from "./TicketChatColumn.vue?vue&type=style&index=0&id=7a77b7b1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a77b7b1",
  null
  
)

export default component.exports